import { render } from "./identity-fast.vue?vue&type=template&id=5c63484a&scoped=true"
import script from "./identity-fast.vue?vue&type=script&lang=js"
export * from "./identity-fast.vue?vue&type=script&lang=js"

import "./identity-fast.vue?vue&type=style&index=0&id=5c63484a&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c63484a"]])

export default __exports__